import React, { useEffect } from "react";

import { BlogBannerWrapper } from "./style";

import {
	Text,
	Grid,
	Col,
	CloudinaryImage,
} from "@website-builder/ui/shared/elements";

const BlogBannerWR = ({
	coverImage = {},
	title = "",
	featuredDescription = "",
	dateOfPublishing = "",
	isIndexPage = false,
	link = "",
	bannerImageSizes,
}) => {
	useEffect(() => {
		//  for iframes that renedered conditionaly
		if (window.lozad) {
			const observer = window.lozad(); // lazy loads elements with default selector as '.lozad'
			observer.observe();
		}
	}, []);
	return (
		<BlogBannerWrapper
			isIndexPage={isIndexPage}
			className="blog-banner-wr"
			as={isIndexPage ? "a" : null}
			href={isIndexPage ? link : null}
			target={isIndexPage ? "_self" : null}
			bannerMaxHeight={bannerImageSizes?.default?.height || 400}
		>
			<Grid hMargin={[0, 0]} vAlign="center">
				<Col span={6} mdSpan={6}>
					<CloudinaryImage
						className="blog-image"
						url={coverImage?.image}
						alt={coverImage?.alt}
						quality="auto"
						lazyload
						fetchFormat="auto"
						preload={true}
						sizes={bannerImageSizes}
					/>
				</Col>
				<Col span={6} mdSpan={6} className="blog-banner-text-content">
					{isIndexPage && featuredDescription ? (
						<Text variant="paragraph_M" className="blog-description">
							{featuredDescription}
						</Text>
					) : null}
					<Text variant={isIndexPage ? "headline_4" : "headline_3"} tag="h1">
						{title}
					</Text>
					{dateOfPublishing ? (
						<Text variant="label_M" className="date-of-publishing">
							{dateOfPublishing}
						</Text>
					) : null}
				</Col>
			</Grid>
		</BlogBannerWrapper>
	);
};

export default BlogBannerWR;
